import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Row from 'reactstrap/lib/Row';
/* Constants */
import { TrackingConstant } from 'client/tracking/constant';
import { FEATURES_CATEGORIES } from 'client/site-modules/shared/constants/inventory/features-and-specs';

import './feature-item.scss';

export function FeatureItem({ features = [], id }) {
  const { icon, title } = FEATURES_CATEGORIES.find(({ featureCategory }) => featureCategory === id) || [];
  const [isItemOpened, setIsItemOpened] = useState(false);

  const handleToggle = useCallback(
    event => {
      setIsItemOpened(!isItemOpened);
      event.preventDefault();
    },
    [isItemOpened]
  );

  return (
    <Row className="feature-item mx-0 px-0 py-1 c-pointer feature-item-modular">
      <details open={isItemOpened} className="w-100">
        <summary
          className="d-flex justify-content-between"
          data-tracking-id="vdp_view_content"
          data-subaction-name={TrackingConstant.VIEW_FEATURES}
          data-tracking-value={title}
          onClick={handleToggle}
          data-no-refresh
        >
          <h3 className="feature-title fw-bold m-0 size-16">
            <i className={classnames('text-gray-darker me-1', icon)} aria-hidden />
            {title}
          </h3>
          <i
            className={classnames('medium text-primary-darker', {
              'icon-arrow-down4': !isItemOpened,
              'icon-arrow-up4': isItemOpened,
            })}
            aria-hidden
          />
        </summary>
        <ul id={id} className="mx-0 mb-0 mt-0_25 ps-2">
          {features.map(({ name }) => (
            <li key={name} className="mt-0_75">
              {name}
            </li>
          ))}
        </ul>
      </details>
    </Row>
  );
}

FeatureItem.propTypes = {
  id: PropTypes.string.isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      optionText: PropTypes.string,
    })
  ),
};
